import defaultColor from "@/components/color";

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"value":42}',
    },
    attribute:{
        title:'速度',titleSize:12,titleColor:'#ddd',titleOffsetTop:30,min:0,max:100,
        detailSize:25,detailColor:'#5d6b81',detailOffsetTop:6,
        radius:90,
        lineWidth:20,color1:defaultColor[1],color2:defaultColor[2],color3:defaultColor[3],itemColor:'#35D0E6',
        startAngle:180,endAngle:0,
        pointerOffsetTop:-15,
        axisLabel: {
            show: true,
            distance: 25,
            color: '#999',
            fontSize: 12
        },
        axisTick: {
            show: true,
            length: 5,
            distance: 5,
            lineStyle: {
                width: 1,
                color: '#ccc'
            }
        },
        pointer: {
            // icon: 'rect',
            length: 75,
            width: 6,
            itemStyle: {
              color: '#35D0E6'
            }
        },
        enableGradual:true,
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    }
}